"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    paddingLeft: props => {
      return theme.spacing(props.padding);
    },
    paddingRight: props => {
      return theme.spacing(props.padding);
    },
    paddingBottom: props => {
      return theme.spacing(props.padding);
    }
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "200px auto",
    gridGap: props => {
      return theme.spacing(props.spacing);
    },
    "& [data-name=media]": {
      minWidth: theme.spacing(25),
      minHeight: theme.spacing(25)
    },
    "& [data-name=content]": {},
    "& [data-name=reference]": {
      gridColumn: "1 / span 2"
    }
  }
}));

const KioskLink = ({
  padding = 2,
  spacing = 2,
  children
}) => {
  const classes = useStyles({
    padding,
    spacing
  });
  return _react.default.createElement("section", {
    className: classes.root
  }, _react.default.createElement("div", {
    className: classes.grid
  }, children));
};

var _default = KioskLink;
exports.default = _default;
module.exports = exports.default;